<template>  
  <div class="orderEvaluate">
    <XR-head titleText="订单评价"></XR-head>
    <div class="form">
      <mu-row gutter>
        <mu-col width="100" tablet="50" desktop="33">
          <div class="evaStar">
            <mu-icon-button icon=":fa fa-star" v-for="(itemClass,index) in itemClasses" :class="itemClass" :key="index" class="star-item" @click="stars(index)"></mu-icon-button><!--性能优化 track-by 数据不改变时不会重新渲染-->
          </div>
        </mu-col>
      </mu-row>
      <mu-row gutter>
        <mu-col width="100" tablet="50" desktop="33">
        <div class="remark">      
          <mu-text-field  label="评价" hintText="请输入您要评价的内容" multiLine :rows="3" :rowsMax="6" :maxLength="50" v-model="evaluateInfo.PjContent" fullWidth />
        </div>
        </mu-col>
      </mu-row>
    </div>
    <mu-row gutter>
      <mu-col width="100" tablet="50" desktop="33" class="button-row">
        <mu-raised-button label="确 定" class="submit" primary fullWidth @click="sellServiceOrderMsg()" />
      </mu-col>
    </mu-row>
    <XR-toast @onClose="goBack" ref="XRtoast"></XR-toast>
  </div>
</template>

<script>
export default {
  data() {
    return {
      evaluateInfo: {
        SkuId: this.$route.query.skuId,
        OrderItemId: this.$route.query.itemId,
        StarLevel:0,
        PjContent: "",
        Images:[]
      }
    };
  },
  mounted() {},
  methods: {
    sellServiceOrderMsg() {
      var ths = this;
      ths
        .$post(
          "/Shop/IntegralServer/IntegralOrderItemEvaluate", this.evaluateInfo
        )
        .then(function(res) {
          if (!res.IsSuccess) {
            ths.$refs.XRtoast.failed(res.Msg, true);
          } else {
            ths.$refs.XRtoast.success(res.Msg, true);
          }
        });
    },
    goBack() {
      this.$router.goBack();
    },
    stars: function(index) {
      this.evaluateInfo.StarLevel = index + 1;
    }
  },
  computed: {
    itemClasses() {
      let result = []; // 返回的是一个数组,用来遍历输出星星
      let score = Math.floor(this.evaluateInfo.StarLevel * 2) / 2; // 计算所有星星的数量
      let hasDecimal = score % 1 !== 0; // 非整数星星判断
      let integer = Math.floor(score); // 整数星星判断
      for (let i = 0; i < integer; i++) {
        // 整数星星使用on
        result.push("on"); // 一个整数星星就push一个CLS_ON到数组
      }
      if (hasDecimal) {
        // 非整数星星使用half
        result.push("half"); // 类似
      }
      while (result.length < 5) {
        // 余下的用无星星补全,使用off
        result.push("off");
      }
      return result;
    }
  }
};
</script>

<style>
.orderEvaluate .form {
  background: white;
  padding: 10px;
}
.orderEvaluate .remark {
  background: white;
}
.orderEvaluate .button-row {
  padding: 40px 20px 0 20px;
}
.orderEvaluate .submit {
  height: 50px;
}

.orderEvaluate .evaStar {
  padding: 30px 0;
  text-align: center;
}
.orderEvaluate .evaStar .star-item {
  font-size: 12px;
  width: 30px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  padding: 3px;
  margin: 0;
  color:#ccc;
}
.orderEvaluate .evaStar .star-item.on{
  color:red;
}
</style>



// WEBPACK FOOTER //
// src/pages/usercenter/integralOrderEvaluate.vue